// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PpTableColSchema from "../../components/premium-partner-report/PpTableColSchema.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getView(premiumPartnerReport) {
  return React.createElement(FetchLoadableViewMapper$Catalyst.make, {
              loadableData: premiumPartnerReport,
              children: (function (param) {
                  return React.createElement(CardComponent$Catalyst.make, {
                              children: React.createElement(TableComponent$Catalyst.make, {
                                    columns: PpTableColSchema.getCardSchema(undefined),
                                    rowData: ReasonReactUtils$Catalyst.sliceList(param.subscription_logs, undefined, 3),
                                    className: "order-table"
                                  })
                            });
                })
            });
}

export {
  getView ,
  
}
/* react Not a pure module */
